'use strict';

/* exported
  menuChannelsCtrl
 */
function menuChannelsCtrl($scope, $rootScope, $location, channelsService) {
  $scope.filters = {};
  $scope.channelsService = channelsService;
  // Make $location available to child directives
  $scope.location = $location; 

  $scope.$watch('filters.search', function(partner) {
    $rootScope.$broadcast('filters.search', (partner || {}).name);
  });

  $scope.$watch('filters.type', function(type) {
    $rootScope.$broadcast('filters.type', (type || {}).slug);
  });

  $scope.$watch('filters.paymentMethod', function(paymentMethod) {
    $rootScope.$broadcast('filters.paymentMethod', (paymentMethod || {}).value);
  });

  $scope.$watch('filters.balanceFrom', function(balanceFrom) {
    $rootScope.$broadcast('filters.balanceFrom', balanceFrom);
  });

  $scope.$watch('filters.balanceTo', function(balanceTo) {
    $rootScope.$broadcast('filters.balanceTo', balanceTo);
  });

  $scope.$on('clearFiltersButtonClicked', function() {
    $rootScope.$broadcast('resetFilters', undefined);
  });
}

/**
 * Created by yuval on 14/12/22.
 */
'use strict';

/* exported
 inventoryChannelsCtrl
 */

function inventoryChannelsCtrl($scope, $rootScope, $location, $uibModal, Restangular, channels, user, channelsService) {
  const pageSize = 20;
  
  $scope.typesMap = {
    b2b: 'B2B',
    whitelabel: 'Whitelabel',
    emails: 'Emails',
    paid: 'Paid',
    referrals: 'Referrals',
    organic: 'Organic',
    'organic-social': 'Organic Social',
    'b2b-redirect': 'B2B Redirect',
    'offline': 'Offline',
    group: 'Group',
    affiliate: 'Affiliate',
    bookingAgent: 'Booking Agent',
  };
  $scope.channelsService = channelsService;
  $scope.user = user;
  const defaultChannelsFilters = {
    excludeRestrictedChannels: true,
    exact: true
  };
  $scope.filters = {};

  var search = $location.search();
  if (search.page && search.page >= 1) {
    $scope.currentPage = search.page;
  } else {
    $scope.currentPage = 1;
  }

  refreshChannels($scope.filters);

  $scope.pageChanged = function() {
    if ($scope.channels) {
      const startIndex = pageSize * ($scope.currentPage - 1);
      $scope.channelsToShow = $scope.channels.slice(startIndex, startIndex + pageSize);
    }
  };

  $scope.$on('filters.search', function(event, data) {
    if ($scope.filters.search !== data) {
      $scope.filters.search = data;

      refreshChannels($scope.filters);
    }
  });

  $scope.$on('filters.type', function(event, data) {
    if ($scope.filters.type !== data) {
      $scope.filters.type = data;

      refreshChannels($scope.filters);
    }
  });

  $scope.$on('filters.paymentMethod', function(event, data) {
    if ($scope.filters.paymentFlow !== data) {  
      $scope.filters.paymentFlow = data;

      refreshChannels($scope.filters);
    }
  });

  $scope.$on('filters.balanceFrom', function(event, data) {
    if ($scope.filters.balanceFrom !== data) {
      $scope.filters.balanceFrom = data;

      refreshChannels($scope.filters);
    }
  });

  $scope.$on('filters.balanceTo', function(event, data) {
    if ($scope.filters.balanceTo !== data) {
      $scope.filters.balanceTo = data;

      refreshChannels($scope.filters);
    }
  });

  $rootScope.$on('channelCreated', function() {
    refreshChannels($scope.filters);
  });

  $scope.$on('resetFilters', function() {
    $scope.filters = {};
    refreshChannels($scope.filters);
  });

  $scope.$watch('channelsService.selectedChannel', function () {
    $scope.localFilters = {
      selectedSupplier: null
    };
  });

  $scope.openCreatePartner = function (){
    $uibModal
      .open({
        templateUrl: 'views/channels/create-channel.html',
        controller: 'CreateChannelCtrl',
        resolve: {
          Restangular: Restangular,
        }
      });
  };

  function refreshChannels() {
    if ($scope.filters.balanceFrom || $scope.filters.balanceTo) {
      $scope.currentPage = 1;

      // There are balance filters so we first fetch balances, get their partners ids
      // and then fetch channels with proper filters and join them with balances
      fetchBalances({
        balanceFrom: $scope.filters.balanceFrom,
        balanceTo: $scope.filters.balanceTo
      }).then((balances) => {
        const applicationsIds = balances.map(balance => balance.applicationId);
        if (applicationsIds.length > 0) {
          fetchChannels(Object.assign({}, defaultChannelsFilters, {
            type: $scope.filters.type,
            paymentFlow: $scope.filters.paymentFlow,
            search: $scope.filters.search,
            applicationsIds: applicationsIds
          })).then((channels) => {
            $scope.totalItems = channels.length;
            $scope.channels = channels.map(channel => (Object.assign({}, channel, {
              balance: (balances.find(balance => balance.applicationId === channel.applicationId) || {}).balance,
              paymentMethod: mapPaymentFlowToDisplayValue(channel)
            })));
  
            $scope.channelsToShow = $scope.channels.slice(0, pageSize);
          });
        } else {
          $scope.channels = [];
          $scope.channelsToShow = [];
          $scope.totalItems = 0;
        }
      });
    } else {
      // There are no balance filters so first we fetch channels with proper filters
      // and then we fetch all balances and join them with channels
      fetchChannels(Object.assign({}, defaultChannelsFilters, {
        type: $scope.filters.type,
        paymentFlow: $scope.filters.paymentFlow,
        search: $scope.filters.search,
      })).then((channels) => {
        $scope.totalItems = channels.length;
        $scope.channels = channels.map(channel => (Object.assign({}, channel, {
          paymentMethod: mapPaymentFlowToDisplayValue(channel)
        })));
        $scope.currentPage = 1;

        const applicationsIds = $scope.channels.filter(channel => channel.type === 'bookingAgent').map(channel => channel.applicationId).filter(Boolean);
        if (applicationsIds.length > 0) {
          fetchBalances({
            applicationsIds: applicationsIds
          }).then((balances) => {
            $scope.channels = $scope.channels.map(channel => (Object.assign({}, channel, {
              balance: (balances.find(balance => balance.applicationId === channel.applicationId) || {}).balance,
            })));
  
            $scope.channelsToShow = $scope.channels.slice(0, pageSize);
          });
        } else {
          $scope.channelsToShow = $scope.channels.slice(0, pageSize);
        }
      });
    }
  }

  function fetchChannels(filters) {
    return Restangular
      .all('v2/channels').getList(filters);
  }

  function fetchBalances(filters) {
    return Restangular
      .all('v2/credits').getList(filters);
  }

  function mapPaymentFlowToDisplayValue(channel) {
    if (channel.type !== 'bookingAgent') {
      return 'N/A';
    }

    switch (channel.paymentFlow) {
      case 'creditline':
        return 'Credit Line';
      case 'credit-card':
        return 'Credit Card';
      default:
        return 'N/A';
    }
  }
}

'use strict';

/* exported
 channelsProvider
 */

function channelsProvider() {
  this.$get = ['Restangular', '$rootScope', 'SearchRestangular', 'ProductFormatterService', function (Restangular, $rootScope, SearchRestangular, ProductFormatterService) {
    var channelsService = {
      activeTab: 0,
      selectedChannel: null,
      liveSearchResults: null
    };

    channelsService.setActiveTab = function (index) {
      this.activeTab = index;
    };

    channelsService.clearSearchResults = function() {
      this.liveSearchResults = null;
    };

    channelsService.save = function() {
      Restangular.all('v2/channels/' + channelsService.selectedChannel._id)
        .customPUT(channelsService.selectedChannel)
        .then(function (response) {
          $rootScope.$emit('notify', {type: 'success', title: 'Partner', message: 'Partner updated with success'});
          Object.assign(channelsService.selectedChannel, response);
        })
        .catch(function() {
          $rootScope.$emit('notify', {type: 'error', title: 'Partner', message: 'Error updating partner'});
        });
    };

    channelsService.retrieveServiceForPartner = function (partnerId) {
       let self = this;
       return Restangular
        .one(`v2/channels/${partnerId}?withCompanies=true&withCreditline=true`)
        .get()
        .then(channel => {
          self.selectedChannel = channel[0];

          return self;
        });
    }

    channelsService.getLiveSearchResults = function(liveResParams) {
      let self = this;
      const formattedDate = moment(liveResParams.date).format('YYYY-MM-DD');

      return SearchRestangular.one('v2', 'trips')
        .get({ 
          fromCity: liveResParams.departure._id, 
          toCity: liveResParams.arrival._id, 
          date: formattedDate,
          utm_source: this.selectedChannel.slug,
          isB2b: true,
          populateStations: true
        }, 
        {
          'X-Distribution-Channel': this.selectedChannel.slug
        })
        .then((trips) => {
          const tripsByProduct = Object.groupBy(trips.data, trip => trip.product._id)

          const parsedProducts = Object.values(tripsByProduct).map(productTrips => {
            const productData = productTrips[0]
            const productTripsByTime = productTrips.sort((a, b) => moment.utc(a.departure.date).diff(moment.utc(b.departure.date)));

            return {
              companyName: productData.operator.name,
              fromName: productData.from.name,
              toName: productData.to.name,
              type: productData.lineType ? productData.lineType : productData.transferType,
              lineClass: productData.lineClass,
              price: productTripsByTime.map(trip => trip.price),
              departureTimes: productTripsByTime.map(trip => trip.departure.date)
            }
          })

           self.liveSearchResults = parsedProducts
          return self
        });
    };

    return channelsService;
  }];



}

'use strict';

/* exported
  editChannelMenuCtrl
 */
function editChannelMenuCtrl($scope, $rootScope, channelsService) {
  $scope.channelsService = channelsService;
  $scope.PARTNER_TAB_INDEX = {
    PROPERTIES: 0,
    INVENTORY_MANAGEMENT: 1,
    LIVE_RESULTS: 2,
    CREDIT_HISTORY: 3,
  };

  $scope.liveResParams = {};

  $scope.submitLiveSearchRes = () => {
    $scope.errors = {};

    if (!$scope.liveResParams.departure) { $scope.errors.departure = "Departure is required" };
    if (!$scope.liveResParams.arrival) { $scope.errors.arrival = "Arrival is required" };
    if (!$scope.liveResParams.date) { $scope.errors.date = "Departure Date is required" };

    if (!Object.keys($scope.errors).length) {
      channelsService.getLiveSearchResults($scope.liveResParams);
    };
  };

  $scope.$watch('channelsService.activeTab', function (activeTab, previousActiveTab) {
    if (activeTab === previousActiveTab) {
      return;
    }

    if(previousActiveTab == $scope.PARTNER_TAB_INDEX.LIVE_RESULTS) {
      $rootScope.$broadcast('channelsService.activeTab', activeTab);
    }

    var search = $location.search();
    search.cartReference = cartReference;
    $location.search(search);
  });
};

'use strict';

/* exported
  editChannelMenuCtrl
 */

function getPropertiesList(channel) {
  switch (channel.type) {
    case 'whitelabel':
      return ['name', 'logos', 'palette', 'isPartnership', 'slug', 'type'];

    case 'b2b':
      return ['name', 'isPartnership', 'slug', 'type', 'redirectApi'];

    case 'b2b-redirect':
      return ['name', 'isPartnership', 'slug', 'type', 'redirectApi', 'utmMedium', 'utmCampaign', 'utmSource'];

    case 'bookingAgent':
      if (channel.paymentFlow === 'creditline') {
        return ['baseUrl', 'agentEmail', 'paymentFlow', 'currency', 'balance', 'markup', 'logos'];
      } else {
        return ['baseUrl', 'agentEmail', 'paymentFlow', 'currency', 'markup', 'logos'];
      }
    default:
      return ['name', 'isPartnership', 'slug', 'type', 'utmMedium', 'utmCampaign', 'utmSource'];
  }
}

function editChannelCtrl($scope, $rootScope, $uibModal, user, Restangular, channelsService) {
  $scope.channelsService = channelsService;

  $scope.filters = {
    selectedSupplier: null
  };
  $scope.allowedToEditProperties = ['utmMedium' , 'utmCampaign', 'name', 'utmSource', 'logos', 'palette', 'key'];
  $scope.propertiesList = getPropertiesList($scope.channelsService.selectedChannel);
  $scope.typesMap = {
    b2b: 'B2B',
    whitelabel: 'Whitelabel',
    emails: 'Emails',
    paid: 'Paid',
    referrals: 'Referrals',
    organic: 'Organic',
    'organic-social': 'Organic social',
    'b2b-redirect': 'B2B Redirect',
    'offline': 'Offline',
    group: 'Group',
    affiliate: 'Affiliate',
    bookingAgent: 'Booking Agent',
  };
  $scope.allowEdit = ['organic-social', 'organic', 'paid', 'emails', 'referrals', 'offline', 'group', 'affiliate', 'whitelabel', 'bookingAgent', 'b2b-redirect'].includes($scope.channelsService.selectedChannel.type);

  $scope.deleteCompany = function(companyId) {
    $scope.channelsService.selectedChannel.inventoryRules.companies.values =
      $scope.channelsService.selectedChannel.inventoryRules.companies.values.filter(company => company._id !== companyId);
  };

  $scope.checkIfObject = function(value) {
    return value !== null && typeof value === 'object';
  };

  $scope.addNewCompany = function() {
    if (!($scope.channelsService.selectedChannel.inventoryRules.companies.values.some(company => company._id === $scope.filters.selectedSupplier._id))) {
      $scope.channelsService.selectedChannel.inventoryRules.companies.values.push({_id: $scope.filters.selectedSupplier._id, name: $scope.filters.selectedSupplier.name});
    }

    $scope.filters.selectedSupplier = null;
  };

  $scope.hasCompanies = function(channel) {
    return (channel && channel.inventoryRules && channel.inventoryRules.companies && channel.inventoryRules.companies.values.length !== 0);
  };

  $scope.openEditProperty = function (property){
    $uibModal
      .open({
        templateUrl: 'views/channels/edit-property.html',
        controller: 'EditChannelPropertyCtrl',
        resolve: {
          Restangular: Restangular,
          user,
          channel: $scope.channelsService.selectedChannel,
          propertyName: [function () { return property; }],
        }
      });
  };

  $rootScope.$on('propertyUpdated', function(event, channel) {
    $scope.channelsService.selectedChannel = channel;
  });

  $rootScope.$on('channelsService.activeTab', function(event, activeTab) {
    $scope.liveResFilters = {};
    channelsService.clearSearchResults();
  });

  $scope.$on('$destroy', function() {
    channelsService.clearSearchResults()
  });

  $scope.liveResFilters = {};

  $scope.clearLiveResFilters= () => {
    $scope.liveResFilters = {};
  };

  $scope.liveResFilter = function(product) {
    const matchesCompany = !$scope.liveResFilters.company ||
        product.companyName.toLowerCase().includes($scope.liveResFilters.company.toLowerCase());

    const matchesDepartureStation = !$scope.liveResFilters.departureStation ||
        product.fromName.toLowerCase().includes($scope.liveResFilters.departureStation.toLowerCase());

    const matchesArrivalStation = !$scope.liveResFilters.arrivalStation ||
        product.toName.toLowerCase().includes($scope.liveResFilters.arrivalStation.toLowerCase());

    const matchesVehicleType = !$scope.liveResFilters.vehicleType ||
        product.type.toLowerCase().includes($scope.liveResFilters.vehicleType.toLowerCase());

    const matchesVehicleClass = !$scope.liveResFilters.vehicleClass ||
        product.lineClass.toLowerCase().includes($scope.liveResFilters.vehicleClass.toLowerCase());

    return matchesCompany && matchesDepartureStation && matchesArrivalStation &&
          matchesVehicleType && matchesVehicleClass;
  };

  $scope.getQueryParam = function(key) {
    var params = ($scope.channelsService.selectedChannel.redirectApi || {}).queryParams || [];
    var param = params.find(function(p) { return p.key === key; });
    return param ? param.value : null;
  };

  $scope.openEditQueryParam = function(key) {
    var channel = $scope.channelsService.selectedChannel;
    if (!channel.redirectApi) {
      channel.redirectApi = { useBaseUrl: false, queryParams: [] };
    }
    if (!channel.redirectApi.queryParams) {
      channel.redirectApi.queryParams = [];
    }

    var currentValue = $scope.getQueryParam(key);

    $uibModal.open({
      templateUrl: 'views/channels/edit-query-param.html',
      controller: 'EditQueryParamCtrl',
      resolve: {
        Restangular: Restangular,
        channel: channel,
        paramKey: [function() { return key; }],
        paramValue: [function() { return currentValue || ''; }]
      }
    });
  };

  $scope.generateKey = function() {
    channelsService.selectedChannel.key = crypto.randomUUID();
    $scope.openEditProperty('key');
  };

  $scope.topUp = function() {
    $uibModal.open({
      templateUrl: 'views/channels/top-up-modal.html',
      controller: 'TopUpModalCtrl',
      resolve: {
        channel: function() {
          return $scope.channelsService.selectedChannel;
        }
      }
    }).result.then(function(result) {
      Restangular.all('v2/credits/top-up').post({
        applicationId: $scope.channelsService.selectedChannel.creditline.applicationId,
        note: result.note,
        amount: result.amount
      }).then(function(response) {
        $rootScope.$emit('notify', {type: 'success', message: 'Top up successful'});
        console.log('Top up response:', response);
        
        // Refresh the channel data after successful top-up
        channelsService.retrieveServiceForPartner($scope.channelsService.selectedChannel._id);
      }).catch(function(error) {
        $rootScope.$emit('notify', {type: 'error', message: 'Top up failed: ' + (error.data && error.data.message || error.statusText)});
        console.error('Top up error:', error);
      });
    }).catch(function(error) {
      if (error !== 'cancel') {
        console.error('Modal error:', error);
      }
    });
  };
}

'use strict';

/* exported
  topUpModalCtrl
 */

function topUpModalCtrl($scope, $uibModalInstance, channel) {
  $scope.model = {
    amount: null,
  };

  $scope.submit = function() {
    if ($scope.topUpForm.$valid) {
      $uibModalInstance.close({
        amount: $scope.model.amount,
        note: $scope.model.note
      });
    }
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };
} 
'use strict';

/* exported
createChannelCtrl
 */

function createChannelCtrl($scope, $rootScope, $uibModalInstance, Restangular) {
  // Set default values
  $scope.paymentFlow = 'creditline';
  $scope.currency = 'USD';
  $scope.markup = 15;
  $scope.offerId = '34';
  
  $scope.saveChannel = function() {
    $scope.createPartnerForm.channelName.$setTouched();
    $scope.createPartnerForm.channelType.$setTouched();
    
    if ($scope.channelType && $scope.channelType.slug === 'bookingAgent') {
      $scope.createPartnerForm.agentEmail.$setTouched();
      $scope.createPartnerForm.currency.$setTouched();
      $scope.createPartnerForm.markup.$setTouched();

      if (!$scope.logo || $scope.logo.length === 0) {
        $scope.createPartnerForm.logo.$setValidity('required', false);
      } else {
        $scope.createPartnerForm.logo.$setValidity('required', true);
      }
    }
    
    if ($scope.createPartnerForm.channelName.$invalid || $scope.createPartnerForm.channelType.$invalid) {
      return;
    }
    
    if ($scope.channelType && $scope.channelType.slug === 'bookingAgent') {
      if ($scope.createPartnerForm.agentEmail.$invalid || 
          $scope.createPartnerForm.currency.$invalid || 
          $scope.createPartnerForm.markup.$invalid ||
          $scope.createPartnerForm.logo.$invalid
        ) {
        return;
      }
    }
    
    const slug = $scope.channelName.replace(/[ _]/g,'-').toLowerCase();
    
    if (!slug) {
      return;
    }

    let logoUrl;
    if ($scope.logo && $scope.logo.length > 0) {
      logoUrl = $scope.logo[0].link;
    }
    
    var payload = {
      name: $scope.channelName,
      type: $scope.channelType.slug,
      paymentFlow: $scope.paymentFlow,
      currency: $scope.currency,
      markup: $scope.markup,
      agentEmail: $scope.agentEmail,
      logoUrl: logoUrl
    };

    if ($scope.channelType.slug === 'b2b-redirect') {
      var queryParams = [{ key: 'offer_id', value: $scope.offerId }];
      if ($scope.affId) queryParams.push({ key: 'aff_id', value: $scope.affId });
      payload.redirectApi = { useBaseUrl: false, queryParams: queryParams };
      if ($scope.utmSource) payload.utmSource = $scope.utmSource;
    }

    Restangular
      .all('v2/channels?ignoreRestrictions=true').post(payload).then(
      () => {
          $rootScope.$emit('channelCreated');
          $uibModalInstance.close();
        }
    )
      .catch(function(err) {
        $rootScope.$emit('notify', {type: 'error', title: 'Partner', message: err.data.status === 400 ? err.data.message : 'Error creating partner'});
      });
  };

  $scope.close = function () {
    $uibModalInstance.close();
  };
}

'use strict';

/* exported
editChannelPropertyCtrl
 */

function editChannelPropertyCtrl($scope, $rootScope, $uibModalInstance, appConfig, Upload, user, Restangular, channel, propertyName) {
  $scope.newPropertyValue = channel[propertyName];
  $scope.propertyName = propertyName;

  if (propertyName === 'logos'){
    $scope.lightLogo = '';
    $scope.darkLogo = '';
  }

  $scope.checkIfObject = function(value) {
    return value !== null && typeof value === 'object';
  };

  $scope.saveChannel = function() {
    const payload = Object.assign(channel, { [propertyName]: $scope.newPropertyValue });

    if (propertyName === 'logosBookingAgent' && (!$scope.logosBookingAgent || !$scope.logosBookingAgent[0])) {
      $scope.editPropertySendForm.logosBookingAgent.$setValidity('required', false);
      return;
    }

    if (propertyName === 'logosBookingAgent') {
      payload.logos = {
        light: $scope.logosBookingAgent[0].link,
        dark: $scope.logosBookingAgent[0].link,
        voucherLogo: $scope.logosBookingAgent[0].link,
      }
    } 

    Restangular
      .all('v2/channels/' + channel._id).customPUT(payload).then(
      (res) => {
        $rootScope.$emit('propertyUpdated', res);
        $uibModalInstance.close();
      }
    );
  };


  $scope.$watch('lightLogo', function() {
    $scope.upload($scope.lightLogo, 'light');
  });

  $scope.$watch('darkLogo', function() {
    $scope.upload($scope.darkLogo, 'dark');
  });

  $scope.upload = function (pictures, label) {
    if (pictures && pictures.length && !pictures.$error) {

      Upload.upload({
        url: appConfig.imagesServiceBaseUrl + '/upload/files',
        arrayKey: '', // http://stackoverflow.com/questions/32917617/multer-not-accepting-files-in-array-format-gives-unexpected-filed-error
        data: {
          owner: user._id,
          files: pictures,
          types: 'picture'
        }
      }).then(function(resp) {
        var images = resp.data;

        if (images && images[0]) {
          const url = '' + appConfig.cdnImageEndpoint + '/' + images[0]._id + '.' + images[0].ext;
          if (label === 'light') {
            $scope.newPropertyValue.light = url;
            $scope.newPropertyValue.voucherLogo = url;
          } else if (label === 'dark') {
            $scope.newPropertyValue.dark = url;
          }
        }

        $scope.$emit('notify', {type: 'success', title: 'Upload', message: 'Image uploaded with Success'});
      }, function() {
        $scope.$emit('notify', {type: 'error', title: 'Upload', message: 'Failed to upload images'});
      });
    }
  };



  $scope.close = function () {
    $uibModalInstance.close();
  };
}

'use strict';

/* exported
editQueryParamCtrl
 */

function editQueryParamCtrl($scope, $rootScope, $uibModalInstance, Restangular, channel, paramKey, paramValue) {
  $scope.paramKey = paramKey;
  $scope.paramValue = paramValue;

  $scope.save = function() {
    if (!$scope.paramValue) {
      return;
    }

    var params = channel.redirectApi.queryParams;
    var existing = params.find(function(p) { return p.key === paramKey; });

    if (existing) {
      existing.value = $scope.paramValue;
    } else {
      params.push({ key: paramKey, value: $scope.paramValue });
    }

    Restangular
      .all('v2/channels/' + channel._id).customPUT(channel).then(
      function(res) {
        $rootScope.$emit('propertyUpdated', res);
        $uibModalInstance.close();
      }
    );
  };

  $scope.close = function() {
    $uibModalInstance.close();
  };
}

'use strict';

/*
exported
channelsPaymentMethodSelectorDirective
 */

function channelsPaymentMethodSelectorDirective() {
  return {
    restrict: 'AE',
    require: 'ngModel',
    templateUrl: 'views/channels/channels-payment-method-selector.directive.html',
    scope: {
      ngModel: '=ngModel',
      showLabel: '=showLabel',
      label: '@',
      location: '='
    },
    link: function(scope, iElement, iAttrs, ngModelCtrl) {
      // Hack for ui-select to update model
      scope.selected = {};

      scope.displayLabel = scope.showLabel === undefined ? true : scope.showLabel;
      scope.paymentMethods = [
        { name: 'All Methods', value: undefined },
        { name: 'Credit Line', value: 'creditline' },
        { name: 'Credit Card', value: 'credit-card' },
      ];

      const paymentMethodFromUrl = scope.location.search().paymentMethod;
      if (!paymentMethodFromUrl) {
        scope.ngModel = scope.paymentMethods[0];
        scope.selected.paymentMethod = scope.paymentMethods[0];
      } else {
        const paymentMethod = scope.paymentMethods.find((method) => method.value === paymentMethodFromUrl);
        scope.ngModel = paymentMethod;
        scope.selected.paymentMethod = paymentMethod;
      }

      scope.updatePaymentMethod = function(paymentMethod) {
        scope.ngModel = paymentMethod;
        setPaymentMethodInUrl(scope, paymentMethod.value);
      };

      scope.$on('resetFilters', function() {
        scope.ngModel = scope.paymentMethods[0];
        scope.selected.paymentMethod = scope.paymentMethods[0];
        setPaymentMethodInUrl(scope, undefined);
      });
    }
  };

  function setPaymentMethodInUrl(scope, paymentMethodValue) {
    if(!scope.location) {
      return;
    }

    const search = scope.location.search();
    search.paymentMethod = paymentMethodValue;
    scope.location.search(search);
  }
} 

'use strict';

/*
exported
channelsBalanceFromSelectorDirective
 */

function channelsBalanceFromSelectorDirective() {
  return {
    restrict: 'AE',
    require: 'ngModel',
    templateUrl: 'views/channels/channels-balance-from-selector.directive.html',
    scope: {
      ngModel: '=ngModel',
      showLabel: '=showLabel',
      label: '@',
      location: '='
    },
    link: function(scope, iElement, iAttrs, ngModelCtrl) {
      // Hack for ui-select to update model
      scope.selected = {};

      scope.displayLabel = scope.showLabel === undefined ? true : scope.showLabel;

      const balanceFromFromUrl = scope.location.search().balanceFrom;
      if (balanceFromFromUrl) {
        scope.ngModel = parseFloat(balanceFromFromUrl);
        scope.selected.balanceFrom = scope.ngModel;
      }

      ngModelCtrl.$validators.required = function(modelValue) {
        return !!(modelValue);
      };

      ngModelCtrl.$formatters.push(function(modelValue) {
        return modelValue;
      });

      ngModelCtrl.$parsers.push(function(viewValue) {
        return viewValue;
      });

      ngModelCtrl.$render = function() {
        scope.selected.balanceFrom = ngModelCtrl.$viewValue;
      };

      scope.updateBalanceFrom = function(value) {
        ngModelCtrl.$setViewValue(value);
        setBalanceFromInUrl(scope, value);
      };

      scope.$on('resetFilters', function() {
        scope.ngModel = undefined;
        scope.selected.balanceFrom = undefined;
        setBalanceFromInUrl(scope, undefined);
      });
    }
  };

  function setBalanceFromInUrl(scope, value) {
    if(!scope.location) {
      return;
    }

    const search = scope.location.search();
    search.balanceFrom = value;
    scope.location.search(search);
  }
} 
'use strict';

/*
exported
channelsBalanceToSelectorDirective
 */

function channelsBalanceToSelectorDirective() {
  return {
    restrict: 'AE',
    require: 'ngModel',
    templateUrl: 'views/channels/channels-balance-to-selector.directive.html',
    scope: {
      ngModel: '=ngModel',
      showLabel: '=showLabel',
      label: '@',
      location: '='
    },
    link: function(scope, iElement, iAttrs, ngModelCtrl) {
      // Hack for ui-select to update model
      scope.selected = {};

      scope.displayLabel = scope.showLabel === undefined ? true : scope.showLabel;

      const balanceToFromUrl = scope.location.search().balanceTo;
      if (balanceToFromUrl) {
        scope.ngModel = parseFloat(balanceToFromUrl);
        scope.selected.balanceTo = scope.ngModel;
      }

      ngModelCtrl.$validators.required = function(modelValue) {
        return !!(modelValue);
      };

      ngModelCtrl.$formatters.push(function(modelValue) {
        return modelValue;
      });

      ngModelCtrl.$parsers.push(function(viewValue) {
        return viewValue;
      });

      ngModelCtrl.$render = function() {
        scope.selected.balanceTo = ngModelCtrl.$viewValue;
      };

      scope.updateBalanceTo = function(value) {
        ngModelCtrl.$setViewValue(value);
        setBalanceToInUrl(scope, value);
      };

      scope.$on('resetFilters', function() {
        scope.ngModel = undefined;
        scope.selected.balanceTo = undefined;
        setBalanceToInUrl(scope, undefined);
      });
    }
  };

    function setBalanceToInUrl(scope, value) {
    if(!scope.location) {
      return;
    }

    const search = scope.location.search();
    search.balanceTo = value;
    scope.location.search(search);
  }
}
'use strict';

/*
exported
clearFiltersButtonDirective
 */

function clearFiltersButtonDirective() {
  return {
    restrict: 'AE',
    templateUrl: 'views/channels/clear-filters-button.directive.html',
    scope: {},
    link: function(scope, iElement, iAttrs) {
      scope.clearFilters = function() {
        scope.$emit('clearFiltersButtonClicked');
      };
    }
  };
} 
